import PropTypes from 'prop-types'
import React from 'react'
import { ThemeContext } from 'styled-components'

import HowToBlock from 'components/_special/HowToBlock'
import SectionWrapper from 'components/SectionWrapper'
import { Text } from 'styles/components/typography'

import scan from './assets/i-scan.jpg'
import { Wrapper, Image } from './styles'

/**
 * BHowAnalyse
 *
 * @param {object} props - properties of component
 * @returns {node} BHowAnalyse
 */
const BHowAnalyse = ({ data, index, isSquareHidden }) => {
  const { colors } = React.useContext(ThemeContext)

  return (
    <SectionWrapper isOverflowHidden={true} classNameInner="pb-4">
      <HowToBlock
        title={data.title}
        index={index}
        squareColor={colors.grass}
        isSquareHidden={isSquareHidden}
      >
        <div className="row">
          <Wrapper className="col-12 order-md-1 col-md-6 offset-lg-1 col-lg-5">
            <Image alt="miseq" className="pb-4 pb-md-0" src={scan} />
          </Wrapper>
          <div className="col-12 order-md-0 col-md-5 col-lg-5 offset-md-1">
            <Text
              className="with-inverted-links"
              dangerouslySetInnerHTML={{ __html: data.content }}
            />
          </div>
        </div>
      </HowToBlock>
    </SectionWrapper>
  )
}

BHowAnalyse.propTypes = {
  data: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  isSquareHidden: PropTypes.bool,
}

BHowAnalyse.defaultProps = {
  isSquareHidden: false,
}

export default BHowAnalyse
